import { useEffect, useState } from 'react';

export default function usePWAInstallPrompt() {
  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setInstallPromptEvent(e);
      setIsReady(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const promptInstall = async () => {
    if (!installPromptEvent) return;
    installPromptEvent.prompt();
    const result = await installPromptEvent.userChoice;
    setInstallPromptEvent(null);
    setIsReady(false);
    return result;
  };

  return { isReady, promptInstall };
}
